import { render, staticRenderFns } from "./bonds.vue?vue&type=template&id=204f65c8&scoped=true&lang=pug"
import script from "./bonds.vue?vue&type=script&lang=js"
export * from "./bonds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204f65c8",
  null
  
)

/* custom blocks */
import block0 from "./bonds.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports